import styled, { keyframes } from 'styled-components';
import ReactSVG from 'react-svg';

import UFOsvg1 from './images/ufo1.svg';
import UFOsvg2 from './images/ufo2.svg';
import UFOsvg3 from './images/ufo3.svg';

export const Wrap = styled.div`
  display: block;

  @media (max-width: 920px) {
    display: none;
  }
`;

const ufo1anim = keyframes`
  0% {
    transform: translate3d(0,0,0) rotate(-10deg);
  }

  50% {
    transform: translate3d(0,20px,0) rotate(-8deg);
  }

  100% {
    transform: translate3d(0,0,0) rotate(-10deg);
  }
`;

const ufo2anim = keyframes`
  0% {
    transform: translate3d(0,0,0);
  }

  50% {
    transform: translate3d(0,10px,0);
  }

  100% {
    transform: translate3d(0,0,0);
  }
`;

const ufo3anim = keyframes`
  0% {
    transform: translate3d(0,0,0);
  }

  50% {
    transform: translate3d(0,-10px,0);
  }

  100% {
    transform: translate3d(0,0,0);
  }
`;

const svgIcon = `width: 100%;
height: 100%;`;

export const UFO1 = styled(ReactSVG).attrs({
  src: UFOsvg1,
})`
  height: 150px;
  width: 150px;
  position: fixed;
  z-index: 10;
  top: 50px;
  left: 100px;
  transform: rotate(-10deg);
  animation: ${ufo1anim} 1.7s ease-in-out infinite;
  animation-fill-mode: forwards;
  svg {
    ${svgIcon};
  }
`;

export const UFO2 = styled(ReactSVG).attrs({
  src: UFOsvg2,
})`
  height: 150px;
  width: 150px;
  position: fixed;
  z-index: 10;
  top: 140px;
  right: 100px;
  animation: ${ufo2anim} 1.7s ease-in-out infinite 0.8s;
  animation-fill-mode: forwards;
  svg {
    ${svgIcon};
  }
`;

export const UFO3 = styled(ReactSVG).attrs({
  src: UFOsvg3,
})`
  position: fixed;
  z-index: 10;
  bottom: 50px;
  right: 300px;
  height: 100px;
  width: 100px;
  animation: ${ufo3anim} 1.7s ease-in-out infinite 1s;
  animation-fill-mode: forwards;

  svg {
    ${svgIcon};
  }
`;
